<mat-form-field [class]="class">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-select id="task-type-select"
        (value)="value"
        (selectionChange)="change($event)"
        [multiple]="multiple">
        <mat-select-trigger>
            <span *ngIf="!multiple">{{ 'task.taskType.' + value | blah }}</span>
            <ng-container *ngIf="multiple">
                <span *ngIf="value?.length >= 1">
                    {{ 'task.taskType.' + value[0] | blah }}
                    <ng-container *ngIf="value?.length > 1"> (+{{ value.length -1 }})</ng-container>
                </span>
            </ng-container>
        </mat-select-trigger>
        <mat-option *ngFor="let taskType of taskTypes"
            [value]="taskType">
            <span [id]="'task-type-select-option-' + taskType"> {{ 'task.taskType.' + taskType | blah }} </span>
        </mat-option>
    </mat-select>
</mat-form-field>